import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';

import { ASetHistory, THistory, TRemote } from '../actions';

const fetchHistoryListeners = [
  THistory.FETCH_HISTORY,
  TRemote.SET_REMOTE,
  // TPlayer.SET_PLAYER_STATUS
];

let fetchHistoryEpicTimeout = 0;

export const fetchHistoryEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => fetchHistoryListeners.includes(type)),
    filter(() => new Date().getTime() - fetchHistoryEpicTimeout > 2000),
    tap( () => fetchHistoryEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get('/history?ngsw-bypass=true').pipe(
      /**
       * There is a common handler for all errors.
      * However, we need to return an empty array in case of an error
      * to prevent the error from being propagated to the upper level.
      * If it is not handled here, this interrupts the flow if the API returns a 404.
       */
      catchError(() => of([])),
    )),
    map(ASetHistory)
  );
